// Content data store - easily editable by church staff
export const siteContent = {
  church: {
    name: "Bright Light Baptist Church",
    tagline: "Where God's love is shared and His plan is preached.",
    phone: "(803) 273-9220",
    email: "blbc@comporium.net",
    address: "4469 Kershaw Camden Hwy, Heath Springs, SC 29058",
    location: "Heath Springs, SC"
  },

  serviceTimes: [
    { name: "Sunday Worship", time: "11:00 AM" },
    { name: "Sunday School", time: "9:50 AM" },
    { name: "Wednesday Bible Study", time: "6:30 PM" },
    { name: "Location", time: "Heath Springs, SC" }
  ],

  hero: {
    title: "Welcome Home",
    subtitle: "Where God's love is shared and His plan is preached.",
    primaryButton: { text: "Plan Your Visit", link: "/contact" },
    secondaryButton: { text: "Learn More", link: "/about" }
  },

  about: {
    story: {
      title: "About Bright Light Baptist Church",
      paragraphs: [
        "For over 140 years, Bright Light Baptist Church has been a cornerstone of faith in the Heath Springs community. What began as a small gathering of believers in 1885 has grown into a vibrant, multi-generational church family united by our love for Jesus Christ and commitment to His Word.",
        "Our journey has been marked by God's faithfulness through every season. From our humble beginnings in a small building to our current facility, we've witnessed countless lives transformed by the power of the Gospel."
      ]
    },
    beliefs: [
      {
        icon: "📖",
        title: "The Bible",
        description: "We believe the Bible is the inspired, inerrant Word of God—our ultimate authority for faith and practice."
      },
      {
        icon: "✝️",
        title: "Salvation Through Christ",
        description: "We believe salvation is a gift of God's grace through faith in Jesus Christ alone."
      },
      {
        icon: "🕊️",
        title: "The Trinity",
        description: "We believe in one God eternally existing in three persons—Father, Son, and Holy Spirit."
      },
      {
        icon: "⛪",
        title: "The Church",
        description: "We believe the church is the body of Christ, called to worship God and reach the world with the Gospel."
      }
    ],
    leadership: [
      { name: "Pastor Mike Johnson", role: "Senior Pastor", icon: "👨‍💼" },
      { name: "Rev. David Thompson", role: "Associate Pastor", icon: "👨‍💼" },
      { name: "Sarah Williams", role: "Worship Leader", icon: "👩‍💼" }
    ],
    timeline: [
      {
        year: "1885",
        title: "Founded",
        description: "Bright Light Baptist Church was established by a small group of dedicated believers."
      },
      {
        year: "1978",
        title: "New Building",
        description: "As our congregation grew, we moved into our current sanctuary."
      },
      {
        year: "1995",
        title: "Youth Ministry Launch",
        description: "We launched a dedicated youth ministry program."
      },
      {
        year: "2010",
        title: "Current Era",
        description: "Pastor Mike Johnson became our senior pastor, leading us into renewed vision and growth."
      }
    ]
  },

  sermons: [
    {
      date: "February 16, 2026",
      title: "Walking in Faith, Not by Sight",
      speaker: "Pastor Mike Johnson",
      description: "Exploring what it means to trust God completely, even when we can't see the path ahead. Based on 2 Corinthians 5:7.",
      icon: "🎤",
      duration: "42 min",
      views: 127,
      videoUrl: "#",
      audioUrl: "#"
    },
    {
      date: "February 9, 2026",
      title: "The Power of Prayer",
      speaker: "Pastor Mike Johnson",
      description: "Understanding prayer as our direct line to God and discovering how it transforms both our circumstances and our hearts.",
      icon: "📖",
      duration: "38 min",
      views: 203,
      videoUrl: "#",
      audioUrl: "#"
    },
    {
      date: "February 2, 2026",
      title: "Grace That Saves",
      speaker: "Pastor Mike Johnson",
      description: "A powerful message about God's amazing grace and how it offers salvation to all who believe. Ephesians 2:8-9.",
      icon: "✝️",
      duration: "45 min",
      views: 189,
      videoUrl: "#",
      audioUrl: "#"
    },
    {
      date: "January 26, 2026",
      title: "Living in the Spirit",
      speaker: "Rev. David Thompson",
      description: "Discovering how the Holy Spirit guides, empowers, and transforms us to live victoriously in Christ.",
      icon: "🕊️",
      duration: "41 min",
      views: 156,
      videoUrl: "#",
      audioUrl: "#"
    },
    {
      date: "January 19, 2026",
      title: "Love One Another",
      speaker: "Pastor Mike Johnson",
      description: "Jesus' command to love is central to our faith. Exploring what it means to love like Christ in our daily lives.",
      icon: "❤️",
      duration: "39 min",
      views: 178,
      videoUrl: "#",
      audioUrl: "#"
    },
    {
      date: "January 12, 2026",
      title: "Strength in Weakness",
      speaker: "Pastor Mike Johnson",
      description: "How God's power is made perfect in our weakness. Finding strength through surrendering to His will. 2 Corinthians 12:9.",
      icon: "🙏",
      duration: "44 min",
      views: 195,
      videoUrl: "#",
      audioUrl: "#"
    }
  ],

  ministries: [
    {
      icon: "👨‍👩‍👧‍👦",
      title: "Youth Ministry",
      leader: "Rev. David Thompson",
      description: "Our youth ministry is dedicated to helping teenagers develop a deep, authentic relationship with Jesus Christ while building lasting friendships with their peers. We create a safe, fun environment where young people can ask questions, explore their faith, and discover their purpose.",
      fullDescription: "Through weekly gatherings, mission trips, and special events, we equip students to live out their faith in their schools, families, and communities.",
      meetingTimes: [
        "Friday Night Youth Group: 6:30 PM - 8:30 PM",
        "Sunday School: 9:50 AM",
        "Summer Mission Trip: July"
      ]
    },
    {
      icon: "🎵",
      title: "Worship Ministry",
      leader: "Sarah Williams",
      description: "Our worship team leads the congregation in lifting praise to God through music, song, and creative expression. We believe worship is more than music—it's a lifestyle of honoring God in everything we do.",
      fullDescription: "Whether you're a vocalist, instrumentalist, or tech-savvy behind the scenes, there's a place for you on our worship team. We welcome all skill levels and provide training and mentorship.",
      meetingTimes: [
        "Choir Practice: Wednesday 6:00 PM",
        "Worship Team Rehearsal: Saturday 10:00 AM",
        "Audio/Visual Team: Sunday mornings"
      ]
    },
    {
      icon: "👶",
      title: "Children's Ministry",
      leader: "Jennifer Martinez",
      description: "We partner with parents to introduce children to Jesus and help them grow in faith from infancy through elementary school. Our curriculum is engaging, age-appropriate, and biblically sound.",
      fullDescription: "From our nursery to Sunday School classes, we create a safe, loving environment where children can learn about God's love, make friends, and have fun while growing in their faith.",
      meetingTimes: [
        "Sunday School (Infant - 5th Grade): 9:50 AM",
        "Children's Church (During service)",
        "Vacation Bible School: Summer",
        "Fall Festival: October"
      ]
    },
    {
      icon: "🤝",
      title: "Outreach Ministry",
      leader: "Deacon James Parker",
      description: "We are called to be the hands and feet of Jesus in our community and beyond. Our outreach ministry serves those in need, shares the Gospel, and demonstrates Christ's love through practical action.",
      fullDescription: "From local food drives to international mission partnerships, we provide opportunities for everyone to make a difference and impact lives for eternity.",
      meetingTimes: [
        "Community Food Pantry: 2nd Saturday monthly",
        "Prison Ministry: Monthly visits",
        "Senior Care Visits: Ongoing",
        "International Missions: Annual trips"
      ]
    }
  ],

  events: [
    {
      icon: "📖",
      title: "Sunday Worship Service",
      date: "Every Sunday · 11:00 AM",
      description: "Join us for inspiring worship, biblical teaching, and fellowship with our church family. Everyone is welcome!",
      recurring: true
    },
    {
      icon: "🙏",
      title: "Wednesday Bible Study",
      date: "Every Wednesday · 6:30 PM",
      description: "Gather with us for corporate prayer, Bible study, and spiritual encouragement midweek.",
      recurring: true
    },
    {
      icon: "🎨",
      title: "Vacation Bible School",
      date: "June 15-19, 2026",
      description: "A week of fun, learning, and growing in faith for children ages 4-12. Theme: Heroes of Faith.",
      recurring: false
    },
    {
      icon: "🍂",
      title: "Fall Festival",
      date: "October 31, 2026",
      description: "Family-friendly fun with games, food, and fellowship. A safe, fun alternative to Halloween for our community.",
      recurring: false
    },
    {
      icon: "🎄",
      title: "Christmas Eve Service",
      date: "December 24, 2026 · 6:00 PM",
      description: "Celebrate the birth of our Savior with candlelight, carols, and the Christmas story.",
      recurring: false
    },
    {
      icon: "🌍",
      title: "Youth Mission Trip",
      date: "July 2026",
      description: "Our youth will serve communities in need while growing in faith and fellowship together.",
      recurring: false
    }
  ]
};
